import React from "react";
import { MeasureTools } from "@ai360/core";

import { NoLink, Pane, SelectInput, Tabs, ToolbarMenu, ToolbarMenuContent } from "~/core";
import { ACTIVE_YN } from "~/core/picklist";
import { IconType, ToolbarIcon } from "../../assets/toolbar-icon";

export class MeasureToolSet extends MeasureTools {
    getToolbar(): JSX.Element {
        const { messages, formatMessage } = this.options;
        return (
            <ToolbarMenu
                testId="map-tools-measure-menu"
                className="measure"
                label={formatMessage(messages.measureLbl)}
                icon={ToolbarIcon(IconType.MEASURE)}
                onToggle={(evt) => this.toggle(evt)}
                activeCount={this.nbrMeasureGraphics}
            >
                <ToolbarMenuContent className="measure-tools">
                    <Tabs
                        selected={this.selectedTab}
                        onTabSelect={(index) => this.selectTab(index)}
                        testId="measure-tools-tabs"
                    >
                        <Pane
                            label={formatMessage(messages.areaTabLbl)}
                            testId="measure-tools-area-pane"
                        >
                            <div className="measure-pane-content">
                                <SelectInput
                                    options={this.areaUnits}
                                    optionIsHiddenKey={ACTIVE_YN}
                                    clearable={false}
                                    placeholderText={formatMessage(messages.areaUnitLbl)}
                                    onChange={(value) => this._updateAreaUnits(value)}
                                    value={this.selectedAreaUnit}
                                    testId="measure-tools-area-unit-select"
                                />
                                <div className="measure-info">{this.area}</div>
                            </div>
                        </Pane>
                        <Pane
                            label={formatMessage(messages.lengthTabLbl)}
                            testId="measure-tools-length-pane"
                        >
                            <div className="measure-pane-content">
                                <SelectInput
                                    options={this.lengthUnits}
                                    optionIsHiddenKey={ACTIVE_YN}
                                    clearable={false}
                                    placeholderText={formatMessage(messages.lengthUnitLbl)}
                                    onChange={(options) => this._updateLengthUnits(options)}
                                    value={this.selectedLengthUnit}
                                    testId="measure-tools-length-unit-select"
                                />
                                <div className="measure-info">{this.length}</div>
                            </div>
                        </Pane>
                        <Pane
                            label={formatMessage(messages.locationTabLbl)}
                            testId="measure-tools-location-pane"
                        >
                            <div className="measure-pane-content">
                                <SelectInput
                                    options={this.coordinateFormat}
                                    optionIsHiddenKey={ACTIVE_YN}
                                    clearable={false}
                                    placeholderText={formatMessage(messages.coordinateFormatLbl)}
                                    onChange={(options) => this._updateCoordinateFormat(options)}
                                    value={this.selectedCoordinateFormat}
                                    testId="measure-tools-coordinate-format-select"
                                />
                                <div className="measure-info">{this.coordinate}</div>
                            </div>
                        </Pane>
                    </Tabs>
                    <div className="clear-measure">
                        <NoLink
                            label={formatMessage(messages.clearMeasurementsLbl)}
                            onClick={() => this._clearMeasurements()}
                        />
                    </div>
                </ToolbarMenuContent>
            </ToolbarMenu>
        );
    }
}
